<template>
        <div class="product-video__wrapper">
            <div ref="DI_Video" class="product-video"></div>
        </div>
</template>
<script>

import { currency } from '@/lib'
import { mapGetters } from 'vuex'
export default {
    data(){
        return {
        }
    },
    mounted(){
        let blueRushVideoScript = document.createElement('script')
        blueRushVideoScript.setAttribute('src', 'https://d2ur3inljr7jwd.cloudfront.net/individeo/prod/edge/js/smartEmbed.js')
        blueRushVideoScript.setAttribute('data-iv-attachment-code', process.env.VUE_APP_BLUE_RUSH_ENV_DI)
        blueRushVideoScript.setAttribute('data-iv-lang', 'en-US')
        blueRushVideoScript.setAttribute('data-iv-use-branding', 'false')
        blueRushVideoScript.setAttribute('data-bp-enable-company-signature', 'false')
        blueRushVideoScript.setAttribute('data-bp-embed-smart-tracking', 'true')
        blueRushVideoScript.setAttribute('data-iv-individeo-data',  JSON.stringify({
            'Broker': this.agent.Name,
            'Employer': this.employer.Name,
            'MinBenefit': this.getMinBenefit(),
            'MaxBenefit': this.getMaxBenefit(),
            'CoverageType': this.product['DICoverageType.GMC'],
            'CoveragePeriod': this.product['DICoveragePeriod.GMC'],
            'CTA': `${window.location.origin}/pdf/${this.$route.params.id}`,
}))
        this.$refs.DI_Video.appendChild(blueRushVideoScript)
    },
    computed: {
        ...mapGetters({
            proposalId: 'getProposalId',
            product: 'getDisabilityIncome',
            employer: 'getEmployer',
            agent: 'getAgent'
        })    
    },
    methods: {
         getMinBenefit(){
            const DIWeeklyBenefitDisplay = this.product['DIWeeklyBenefitDisplay.GMC']
            if(DIWeeklyBenefitDisplay === 'Custom') {
                return currency.format.USD(this.product['DIWeeklyBenefitCustomMin.GMC'])
            } else {
                const DIMinWeeklyBenefit = this.product['DIWeeklyBenefitDisplay.GMC'].split('$')[1].replace(/D/g, '')
                return this.product['DIWeeklyBenefitCustomMin.GMC'] ? currency.format.USD(this.product['DIWeeklyBenefitCustomMin.GMC']) : currency.format.USD(DIMinWeeklyBenefit)    
            }
        },
        getMaxBenefit(){
            const DIWeeklyBenefitDisplay = this.product['DIWeeklyBenefitDisplay.GMC']
            if(DIWeeklyBenefitDisplay === 'Custom') {
                return currency.format.USD(this.product['DIWeeklyBenefitCustomMax.GMC'])
            } else {
                const DIMaxWeeklyBenefit = this.product['DIWeeklyBenefitDisplay.GMC'].split('$')[2].replace(/D/g, '')
                return this.product['DIWeeklyBenefitCustomMax.GMC'] ? currency.format.USD(this.product['DIWeeklyBenefitCustomMax.GMC']) : currency.format.USD(DIMaxWeeklyBenefit)
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.product-video__wrapper {
    position: relative;
    width: 100%;
		padding-bottom: calc(56.25% - 6px);
		border: 5px solid $gray;
		background: #ffffff;
}
.product-video {
    height: 0;
    width: 100%;

}
</style>
